/* eslint-disable @typescript-eslint/no-unused-vars */
export const logMainJsActionExecution = (
  actionId: string,
  isSuccess: boolean,
  collectionId: string,
  isDirty: boolean,
) => {};
